<template>
<div v-bind:class="{ 'line': true, 'line_border': !first }">

    <div class="label">
        {{label}}:
    </div>

    <div v-if="intervals.length == 0" class="chip_container">
        <v-chip
            class="ma-2"
            dense
            >
            {{label_no_intervals}}
        </v-chip>
    </div>

    <div v-if="intervals.length > 0 && !read_only" class="chip_container">
        <v-chip
            v-for="(interval, index) in intervals"
            class="ma-2"
            :close="!read_only"
            v-on:click:close="removeInterval(index)"
            v-on:click="onClickEditInterval(index)"
            dense
            :key="index"
            >
            {{interval}}
        </v-chip>
    </div>

    <div v-if="intervals.length > 0 && read_only" class="chip_container">
        <v-chip
            v-for="(interval, index) in intervals"
            class="ma-2"
            :close="false"
            dense
            :key="index"
            >
            {{interval}}
        </v-chip>
    </div>

    <div class="dot_container" v-if="!read_only">
        <v-menu 
            bottom 
            offset-y  
        >

        <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-dots-vertical
            </v-icon>
                
        </template>

        <v-list>
            <v-list-item
            v-for="(item, menu_item_index) in menu_items"
            :key="menu_item_index"
            v-on:click="onClickMenuItem(item)"
            >
            <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
        </v-list>

        </v-menu> 
    </div>

    <m-interval-dialog
        v-if="!read_only"
        ref="add-interval-dialog"
        title="Add"
        v-on:ok="onAddInterval"
    />

     <m-interval-dialog
        v-if="!read_only"
        ref="edit-interval-dialog"
        title="Edit"
        v-on:ok="onEditInterval"
    />

    <m-date-picker-dialog
        v-if="!read_only"
        ref="choose-date-dialog"
        title="Select Date"
        v-on:ok="onChangeDate"
    />

    
</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        first: {
            type: Boolean,
            default: function() { return false; }
        },

        label: {
            type: String,
            default: function() { return "Schedule"; }
        },

        label_no_intervals: {
            type: String,
            default: function() { return "Closed"; }
        },

        value: {
            type: Array,
            default: function() { return []; }
        },

        read_only: {
            type: Boolean,
            default: function() { return true; }
        },

        date: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            intervals: [],
            last_edit_interval: null,
        }
    },

    mounted () {
        this.setIntervals(this.value);
    },

    methods: {
        setIntervals(val)
        {
            this.intervals = _.cloneDeep(val);
        },

        removeInterval(index) {
            this.intervals.splice(index,1);
            this.onChange();
        },

        onChange()
        {
            this.$emit('input',this.intervals);
        },

        onClickMenuItem(item)
        {
            if ( item.code == 'add' )
            {
                this.edit_index = -1;
                this.$refs['add-interval-dialog'].showDialog("9:00 AM - 5:00 PM");
            }

            if ( item.code == 'copy_weekend')
            {
                this.$emit('copy_weekend', this.value);
            }

            if ( item.code == 'copy_weekday')
            {
                this.$emit('copy_weekday',this.value);
            }

            if ( item.code == 'delete')
            {
                this.$emit('delete');
            }

            if ( item.code == 'copy_all' )
            {
                this.$emit('copy_all', this.value);
            }

            if ( item.code == 'change-date' )
            {
                this.$refs['choose-date-dialog'].showDialog(this.date);
            }
        },

        onChangeDate(new_date)
        {
            this.$emit('change-date',new_date);
        },

        onAddInterval(new_interval)
        {
            this.intervals.push(new_interval);
            this.normalizeIntervals();
        },

        normalizeIntervals()
        {
            this.$rc.showSpinner();
            
            this.$rc.normalizeIntervals(
                this.intervals,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.intervals = data;
                    this.onChange();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to normalize intervals.');
                },
            );
        },

        onClickEditInterval(index)
        {
            this.last_edit_interval = index;
            this.$refs['edit-interval-dialog'].showDialog(this.intervals[index]);
        },

        onEditInterval(new_interval)
        {
            this.intervals[this.last_edit_interval] = new_interval;
            this.normalizeIntervals();
        },
    },

    computed: {
        menu_items() {
            let menu_items = [];

            menu_items.push({ 'text' : 'Add...', 'code' : 'add' });

            let is_weekday = this.label == 'Monday' || this.label == 'Tuesday' || this.label == 'Wednesday' || this.label == 'Thursday' || this.label == 'Friday';
            let is_weekend = this.label == 'Saturday' || this.label == 'Sunday';
            let is_custom = !is_weekday && !is_weekend;

            if ( is_weekday )
            {
                menu_items.push({ 'text' : 'Copy to all week days', 'code' : 'copy_weekday' });
            }

            if ( is_weekend )
            {
                menu_items.push({ 'text' : 'Copy to all weekend days', 'code' : 'copy_weekend' });
            }

            if ( is_custom )
            {
                menu_items.push({ 'text' : 'Delete '+this.label, 'code' : 'delete' });
                menu_items.push({ 'text' : 'Change Date...', 'code' : 'change-date' });
            }

            if ( !is_custom )
            {
                menu_items.push({ 'text' : 'Copy to all days', 'code' : 'copy_all' });
            }

            return menu_items;
        }
    },

    watch: {
        value(newValue, oldValue) {
            this.setIntervals(newValue);
        }
    },
}
</script>

<style lang="scss" scoped>

.line
{
    display: flex;
    flex-direction: row;
}

.line_border
{
    border-top: 1px solid rgb(232,232,232);
}

.label
{
    padding-top: 12px;
    width: 90px;
    min-width: 90px;
    font-family: Roboto, "Helvetica Neue", sans-serif, NotoColorEmoji, "apple color emoji", "windows emoji", "windows symbol";
    font-size: 14px;
}

.chip_container
{
    flex-grow: 1;
}

.dot_container
{
    padding-top: 12px;
}
</style>